// src/components/RoleRoute.js
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const RoleRoute = ({ roles, children }) => {
  const { user, isAuthenticated, loading } = useAuth();

  console.log(roles, 'roles')
  console.log(children, 'children')

  if (loading) return <p>Loading...</p>;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !roles.includes(user?.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default RoleRoute;
